<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <v-row class="ma-0" align="center">
                <h2 class="dashboard">
                    {{ connectorType === 'whatsappBasis' ? 'Настройки бота' : connectorAvatar ? (isChannel ? `Настройки канала «${connectorAvatar.name}»` : isTelephony ? `Настройки телефонии «${connectorAvatar.name}»` : `Настройки источника «${connectorAvatar.name}»`) : 'Загрузка' }}
                </h2>
                <HintIcon v-if="hintId" :hintId="hintId"></HintIcon>
            </v-row>
            <!-- Для каналов используем ChannelSettingsForm -->
            <ChannelSettingsForm
                v-if="isChannel && !isLoadingChannelSettings && providerType"
                :value="channelSettings"
                :connector="connector"
                :providerType="providerType"
                :appCreated="appCreated"
                :mode="'edit'"
                @input="channelSettings = $event"
            />
            <!-- Для остальных источников используем стандартные компоненты -->
            <component
                v-else-if="!isChannel && activeComponent"
                @cancel="cancel"
                @changeSettings="changeSettings"
                :is="activeComponent"
                :isChange="true"
                :connector="connector"
            ></component>

            <h2 class="dashboard" v-else-if="!isChannel">
                {{ connectorAvatar ? 'В настоящее время настройки в этом источнике не поддерживаются' : '' }}
            </h2>
            <div v-else-if="isChannel && isLoadingChannelSettings" class="mt-12 d-flex justify-center">
                <v-progress-circular indeterminate color="mainNew"></v-progress-circular>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex'
import Markers from '@/components/addConnector/Markers.vue'
import Breadcrumbs from '@/components/Breadcrumbs'
import settingsList from '@/components/connectorSettings/list'
import HintIcon from '@/components/HintIcon.vue'
import { CONNECTOR_TYPES, CHANNEL_TYPES, TELEPHONY_CONNECTOR_TYPES } from '@/vars/general.js'
import cfg from '@root/config.js'
export default {
    name: 'ConnectorSettings',
    components: {
        HintIcon,
        Markers,
        Breadcrumbs,
        ChannelSettingsForm: () => import('@/components/channels/ChannelSettingsForm.vue'),
    },
    data: () => ({
        CONNECTOR_TYPES,
        CHANNEL_TYPES,
        TELEPHONY_CONNECTOR_TYPES,
        changedSettingsImportance: null,
        additionalSettingsData: null,
        settings: null,
        channelSettings: {},
        isLoadingChannelSettings: false,
        appCreated: true,
        yCSimpleAuth: cfg.yClientSimpleAuth,
    }),

    computed: {
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        hintId() {
            let hintId = null
            if (this.connectorType === CONNECTOR_TYPES.yClients) {
                //hintId = 'ycSettings'
            }
            return hintId
        },
        breadcrumbs() {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'НАСТРОИТЬ ИСТОЧНИК',
                    disabled: true,
                    to: '',
                },
            ]
        },
        isChangeConnectorSettingsDialog: {
            get() {
                return this.$store.state.project.isChangeConnectorSettingsDialog
            },
            set(value) {
                this.$store.commit('project/updateIsChangeConnectorSettingsDialog', value)
            },
        },
        connector() {
            return this.$store.getters['connectorById'](this.$router.currentRoute.params.connectorId)
        },
        connectorType() {
            return this.connector ? this.connector.connectorType : null
        },
        connectorAvatar() {
            return this.connector
                ? this.$store.getters['connectorAvatarByType'](this.connector.connectorType)
                : null
        },
        settingsImportance() {
            return this.connector
                ? this.$store.getters['connectorSettingsImportanceByType'](this.connector.connectorType)
                : null
        },
        activeComponent() {
            return settingsList.find(el => el.connectorType === this.connector.connectorType)?.component
        },
        isChannel() {
            if (!this.connector) return false
            // Проверяем, является ли connectorType каналом
            const channelTypes = Object.values(CHANNEL_TYPES)
            return channelTypes.includes(this.connector.connectorType)
        },
        isTelephony() {
            if (!this.connector) return false
            // Проверяем, является ли connectorType телефонией
            return TELEPHONY_CONNECTOR_TYPES.includes(this.connector.connectorType)
        },
        providerType() {
            if (!this.connector) return null
            // Получаем providerType из коннектора
            return this.connector.providerType || null
        },
    },
    methods: {
        async changeSettings({ prevSettings, settings, additionalData }) {
            // Сохраняем настройки и ждем завершения (включая запрос на получение коннектора)
            await this.$store.dispatch('project/updateConnectorSettings', {
                connectorId: this.connector.connectorId,
                settings: settings,
            })
            this.cancel()
        },
        cancel() {
            const projectPath = this.$router.currentRoute.path
                .split('/')
                .slice(0, 3)
                .join('/')
            this.$router.push(`${projectPath}#connectors`)
        },
    },
    created() {
        this.$on('changeSettings', this.changeSettings)
        this.$on('cancel', this.cancel)
        this.$on('goToProject', this.cancel)
    },
    mounted() {},
}
</script>
<style lang="sass" scoped>
.connectorSettings
    padding-top: 5%
    padding-left: 10%
    padding-right: 10%
.cancel-btn
    border-color: #0000001F
</style>
